/* lp-evolve: the gallery, plans and cart belong to the buy-box script.
   The marquee and reviews are already rendered. No reference-store data is
   needed to initialise this independent sticky button. */
(function () {
  function lpEvolveStickyParts() {
    return {
      bar: document.querySelector('[data-lp-sticky]'),
      buy: document.querySelector('.buy-box button.add-to-cart[data-evolve-buy]')
    };
  }

  function lpEvolveStickyVisibility() {
    var parts = lpEvolveStickyParts();
    if (parts.bar) {
      parts.bar.classList.toggle('is-visible', !!parts.buy &&
        parts.buy.getBoundingClientRect().bottom < 0);
    }
  }

  function lpEvolveStickyPrice() {
    var parts = lpEvolveStickyParts();
    if (!parts.bar || !parts.buy) return;
    var radio = parts.buy.closest('.buy-box').querySelector(
      'input[name="purchase-option"]:checked');
    var card = radio && radio.closest('.plan-card');
    var price = parts.bar.querySelector('[data-evolve-cart-price]');
    if (!card || !price) return;
    // Each plan carries its own prices, already written out by Shopify in the
    // shopper's own currency. The bar copies them. It must never do its own
    // arithmetic on the words: that assumed a dollar sign and two decimals, so
    // it printed a US total to a Canadian buying in Canadian dollars.
    var amount = radio.dataset.stickyPrice;
    var was = radio.dataset.stickyCompare;
    // No price on the card means the section could not read one from the store.
    // Leave the bar showing what the server wrote rather than guess at it.
    if (!amount) return;
    price.textContent = '';
    if (was) {
      var strike = document.createElement('s');
      strike.textContent = was;
      price.appendChild(strike);
      price.appendChild(document.createTextNode(' '));
    }
    price.appendChild(document.createTextNode(amount));
    var button = parts.bar.querySelector('[data-lp-sticky-add]');
    if (button) button.disabled = parts.buy.disabled || radio.dataset.available === 'false';
  }

  function lpEvolveStickyRefresh() {
    lpEvolveStickyVisibility();
    lpEvolveStickyPrice();
  }

  window.addEventListener('scroll', lpEvolveStickyVisibility, { passive: true });
  window.addEventListener('resize', lpEvolveStickyVisibility);
  window.addEventListener('load', lpEvolveStickyRefresh);
  window.addEventListener('pageshow', lpEvolveStickyRefresh);
  document.addEventListener('shopify:section:load', lpEvolveStickyRefresh);
  document.addEventListener('change', function (event) {
    if (event.target.matches('.buy-box input[name="purchase-option"]')) {
      lpEvolveStickyPrice();
    }
  });
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-lp-sticky-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    // Allan, 12/09/2026: the bar takes the reader to the buy box to choose a
    // plan, the same destination as the call to action mid page. It used to add
    // whichever plan happened to be selected straight to the cart.
    var target = document.getElementById('buy-box') ||
      document.querySelector('.buy-box');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lpEvolveStickyRefresh, { once: true });
  } else {
    lpEvolveStickyRefresh();
  }
})();
